import { NavBar } from "@components/ui-kit";
import { Trans } from "@lingui/macro";
import { observer } from "mobx-react-lite";
import { useRouter } from "next/router";
import type { FC } from "react";
import { AppSubNav } from "../AppSubNav";

interface NavigationProposalsProps {
  onSelect?: () => void;
}

const NavigationProposals: FC<NavigationProposalsProps> = ({ onSelect }) => {
  const { pathname, push } = useRouter();

  return (
    <AppSubNav>
      <NavBar.Item
        href="/budgets/export"
        active={
          pathname.endsWith("/budgets/export") ||
          pathname.endsWith("/budgets/proposals")
        }
      >
        <Trans>Budgets</Trans>
      </NavBar.Item>
      <NavBar.Item
        href="/budgets/quotes"
        active={
          pathname.includes("/budgets/quotes") ||
          pathname.includes("/budgets/edit-quote")
        }
      >
        <Trans>Quotes</Trans>
      </NavBar.Item>
      <NavBar.Item
        onClick={() => {
          push("/budgets/positions");
          onSelect?.();
        }}
        active={pathname === "/budgets/positions"}
      >
        <Trans>Positions</Trans>
      </NavBar.Item>
      <NavBar.Item
        onClick={() => {
          push("/budgets/hourly-rates");
          onSelect?.();
        }}
        active={pathname === "/budgets/hourly-rates"}
      >
        <Trans>Hourly rates and commissions</Trans>
      </NavBar.Item>
    </AppSubNav>
  );
};

export default observer(NavigationProposals);
